import React, { useEffect, useState } from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { Text1, Text3 } from '../../../styles';
import { Form, Button, Input, Tabs } from 'antd';
import { get } from 'lodash';

const { TabPane } = Tabs;

let InstaCommissionModalForm = (props) => {
    const { form, merchant } = props;
    const { getFieldDecorator } = form;
    const va_settings = merchant.smart_collect_virtual_account_settings || {}


    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            let payload = {};
            if (err) return;
            Object.keys(values).forEach(commission_type => {
                if (commission_type.includes("_commission_charges")){
                    let charges_type = commission_type.replace("_commission_charges",'')
                    payload[charges_type] = {}
                    Object.keys(values[commission_type]).forEach(field_name => {
                        const payment_category = field_name.split("_")[0];
                        const min_txn_amount = field_name.split("_")[1];
                        const max_txn_amount = field_name.split("_")[2];
                        const type = field_name.split("_")[3];
                        let category_charge = {};
                        payload[charges_type][payment_category] = payload[charges_type][payment_category] || [];
                        if (max_txn_amount != "any") {
                            category_charge.max_txn_amount = parseFloat(max_txn_amount);
                        }
                        if (min_txn_amount != "any") {
                            category_charge.min_txn_amount = parseFloat(min_txn_amount);
                        }
                        if (type == "percent") {
                            category_charge.charge_in_percent = true;
                        }
                        category_charge.charge = parseFloat(values[`${charges_type}_commission_charges`][field_name].toFixed(2));
                        payload[charges_type][payment_category].push(category_charge);
                    });
                }
            })
            payload["id"] = values.id
            payload["reseller_custom_virtual_account_charges"] = { charge: parseFloat(values.reseller_custom_virtual_account_charges)}
            props.onSubmit(payload);
        });
    };

    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>Set Insta Collect Charges</Text1>
        )
    };

    const renderCharges = (type, service_charges, commission_charges) => {
        const service_charge = service_charges || {};
        const commission_charge = commission_charges || {};
        return (
            <div className="row">
                {
                    Object.keys(service_charge).map(payment_category => {
                        return (
                            <div className="col-sm" style={{ minWidth: 250 }}>
                                <Text3 className="ml-1" type="secondary">{payment_category}</Text3>
                                <div className="p-3 border rounded mb-1" style={{ backgroundColor: "#F8F8F8" }}>
                                    {
                                        service_charge[payment_category].map((category_charges, category_index) => {
                                            const charge_in_percent = !!category_charges.charge_in_percent;
                                            // const commission = commission_charge ? commission_charge[payment_category][category_index]["charge"] : 0;
                                            const commission = commission_charge ? get(commission_charge,`[${payment_category}][${category_index}]["charge"]`, 0) :0;
                                            const commission_key = `${type}_commission_charges.${payment_category}_${category_charges.min_txn_amount == undefined ? "any" : category_charges.min_txn_amount}_${category_charges.max_txn_amount == undefined ? "any" : category_charges.max_txn_amount}_${charge_in_percent ? "percent" : "amount"}`
                                            const service_charge_key = `${type}_service_charges.${payment_category}_${category_charges.min_txn_amount == undefined ? "any" : category_charges.min_txn_amount}_${category_charges.max_txn_amount == undefined ? "any" : category_charges.max_txn_amount}_${charge_in_percent ? "percent" : "amount"}`
                                            let label = "";
                                            if (category_charges.min_txn_amount == undefined && category_charges.max_txn_amount == undefined) {
                                                label = "Any amount";
                                            }
                                            else if (category_charges.max_txn_amount == undefined && category_charges.min_txn_amount != undefined) {
                                                label = `₹ ${category_charges.min_txn_amount} and above`;
                                            }
                                            else if (category_charges.max_txn_amount != undefined && category_charges.min_txn_amount != undefined) {
                                                label = `₹ ${category_charges.min_txn_amount} - ${category_charges.max_txn_amount}`;
                                            }

                                            return (
                                                <>
                                                    {getFieldDecorator(commission_key, {
                                                        initialValue: commission,
                                                    })(<Input autoComplete='off' type="hidden" />)}
                                                    <Form.Item
                                                        label={label}
                                                        help={
                                                            form.getFieldError(service_charge_key) && form.getFieldError(service_charge_key).length ?
                                                                form.getFieldError(service_charge_key)[0]
                                                                :
                                                                `Commission: ${charge_in_percent ?
                                                                    `${(form.getFieldValue(commission_key) && form.getFieldValue(commission_key).toFixed(2)) || 0} %`
                                                                    :
                                                                    `₹ ${(form.getFieldValue(commission_key) && form.getFieldValue(commission_key).toFixed(2)) || 0} /-`
                                                                }`
                                                        }
                                                    >
                                                        {getFieldDecorator(service_charge_key, {
                                                            initialValue: parseFloat((category_charges.charge + commission).toFixed(2)),
                                                            getValueFromEvent: e => {
                                                                const convertedValue = Number(e.currentTarget.value);
                                                                if (isNaN(convertedValue)) {
                                                                    return Number(this.props.form.getFieldValue(service_charge_key));
                                                                } else {
                                                                    return convertedValue;
                                                                }
                                                            },
                                                            rules: [{
                                                                required: true,
                                                                type: "number",
                                                                min: category_charges.charge,
                                                                message: "Charge amount is invalid."
                                                            }]
                                                        })(<Input autoComplete='off' type="number" prefix={charge_in_percent ? "%" : "₹"} onChange={e => { form.setFieldsValue({ [commission_key]: parseFloat(e.target.value) - category_charges.charge }) }} />)}
                                                    </Form.Item>
                                                </>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    };

    return (
        <EaseModal
            width={600}
            title={false}
            visible={props.visible}
            onCancel={props.toggleInstaCommissionModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <Form onSubmit={onSubmit}>
                {getFieldDecorator("id", {
                    initialValue: merchant.id
                })(<Input autoComplete='off' hidden />)}
                <Tabs defaultActiveKey='1'>                    
                    <TabPane tab="CVA Transaction Charges" key="1">
                            {renderCharges("reseller_custom_va_transaction_charges", va_settings.custom_va_transaction_charges || {}, va_settings.reseller_custom_va_transaction_charges || {})}
                    </TabPane>
                    <TabPane tab="Settlement Charges" key="2">
                            {renderCharges("reseller_settlement_charges", va_settings.settlement_charges || {}, va_settings.reseller_settlement_charges || {})}
                    </TabPane>
                    <TabPane tab="Refund Charges" key="3">
                            {renderCharges("reseller_refund_charges", va_settings.refund_charges || {}, va_settings.reseller_refund_charges || {})}
                    </TabPane>
                    <TabPane tab="Custom Virtual Account Charges" key="4">
                        { va_settings.custom_virtual_account_charges && va_settings.reseller_custom_virtual_account_charges ? 
                            <>
                                {getFieldDecorator("reseller_custom_virtual_account_charges", {
                                    initialValue: va_settings.reseller_custom_virtual_account_charges.charge,
                                })(<Input autoComplete='off' type="hidden" />)}
                                <Form.Item
                                    label={"Custom Virtual Account Charges"}
                                    help={
                                        `Commission: ₹ ${form.getFieldValue("reseller_custom_virtual_account_charges")}`
                                    }
                                >
                                {getFieldDecorator("custom_virtual_account_charges", {
                                    initialValue: parseFloat((va_settings.reseller_custom_virtual_account_charges.charge + va_settings.custom_virtual_account_charges.charge)).toFixed(2),
                                })(<Input autoComplete='off' type="number" prefix={"₹"} onChange={e => { form.setFieldsValue({ ["reseller_custom_virtual_account_charges"]: parseFloat(e.target.value) - va_settings.custom_virtual_account_charges.charge }) }}/>)}
                                </Form.Item>
                            </>
                        : null}
                    </TabPane>
                </Tabs>
                <div className="w-100 d-flex justify-content-end mt-4">
                    <Button type="primary" htmlType="submit" loading={props.loading} >Submit</Button>
                </div>
            </Form>
        </EaseModal>
    )
};

const InstaCommissionModal = Form.create()(InstaCommissionModalForm);

export { InstaCommissionModal };